import React from 'react'
import { useKYCformStepsContext } from '../../../../context/KYCformContext';
import { SERVICE_TYPES } from '../../../../utils/constants/fieldErrors';
import SimpleAgreement from '../../../common/simpleAgreement'

export default function Agreement() {
  const { setRedirectUrl } = useKYCformStepsContext();

  return (
      <SimpleAgreement  serviceType = {SERVICE_TYPES.KYCform} setRedirectUrl={setRedirectUrl} pathForRedirect={'/KYCform'}/>
  )
}
